enum ChevronDirectionEnum {
    LEFT = "left",
    DOWN = "down",
    UP = "up",
    RIGHT = "right",
}

export default ChevronDirectionEnum;
